<div class="page-container">
  @if (reports.length) {
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getNameText() }}
        </th>
        <td mat-cell *matCellDef="let report">{{ report.name }}</td>
      </ng-container>

      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getYearText() }}
        </th>
        <td mat-cell *matCellDef="let report">{{ report.year }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getStatusText() }}
        </th>
        <td mat-cell *matCellDef="let report">{{ report.status }}</td>
      </ng-container>

      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getTagsText() }}
        </th>
        <td mat-cell *matCellDef="let report">
          {{ getReportTagsText(report.tags) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getCreatedAtText() }}
        </th>
        <td mat-cell *matCellDef="let report">
          {{ report.createdAt | date: 'MMMM d, y h:mm a' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastEditedAt">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getLastEditedAtText() }}
        </th>
        <td mat-cell *matCellDef="let report">
          {{ report.lastEditedAt | date: 'MMMM d, y h:mm a' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="publishedAt">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getPublishedAtText() }}
        </th>
        <td mat-cell *matCellDef="let report">
          {{
            report.publishedAt
              ? (report.publishedAt | date: 'MMMM d, y h:mm a')
              : '—'
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getActionsText() }}
        </th>
        <td mat-cell *matCellDef="let report">
          <button
            mat-icon-button
            [disabled]="report.status !== 'in-progress'"
            (click)="onEdit(report)"
            [matTooltip]="translationService.getEditText()"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            [matTooltip]="translationService.getDownloadRawDataText()"
            (click)="onDownloadRawData(report.id, report.name)"
          >
            <mat-icon>file_download</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="report.status !== publishedStatus"
            [matTooltip]="translationService.getDownloadPublishedText()"
            (click)="onDownloadPublishedReport(report.id, report.name)"
          >
            <mat-icon>description</mat-icon>
          </button>
          <button
            mat-icon-button
            [disabled]="report.status !== 'published'"
            [matTooltip]="translationService.getCopyAndModifyText()"
            (click)="onCopyModify(report)"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="dataSource.data.length"
      [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50]"
      showFirstLastButtons
    />
  } @else {
    <div class="empty-message">
      {{ translationService.getNoReportsText() }}
    </div>
  }
</div>
